module.exports = __webpack_public_path__ + "static/ZT_img-76ce82c731e4d923a335590d66976053.png";